export const CREATE_CLIENT = "CREATE_CLIENT";
export const EDIT_CLIENT = "EDIT_CLIENT";
export const FETCH_CLIENT_LIST = "FETCH_CLIENT_LIST";
export const DESTROY_CLIENT = "DESTROY_CLIENT";
export const SELECT_CLIENT = "SELECT_CLIENT";
export const TOG_CLIENT_STATUS = "TOG_CLIENT_STATUS";
export const UPDATE_CLIENT_FILTER = "UPDATE_CLIENT_FILTER";
export const RESET_SELECTED_CLIENT = "RESET_SELECTED_CLIENT";
export const SEARCH_CLIENT = "SEARCH_CLIENT";
export const STORE_SERVER_MESSAGE = "STORE_SERVER_MESSAGE";
export const PIN_CODE_VERIFICATION = "PIN_CODE_VERIFICATION";
export const FETCH_SERVER_MESSAGES = "FETCH_SERVER_MESSAGES";
export const RESET_FETCHED_SERVER_MESSAGES = "RESET_FETCHED_SERVER_MESSAGES";
export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED';
export const AUTH_TOKEN = 'AUTH_TOKEN';